<template>
  <div class="CreateBandLyrics">
    <MainPageHeader v-if="!isAndroidContext"/>
    <LoaderLyrics v-if="!bandLyric" :title="'Dodajesz piosenkę'" />
    <BandLyricForm
        :isAndroidContext="isAndroidContext"
        v-else
        :bandLyric="bandLyric"
        :saving="saving"
        :isEditingMode="isEditingMode"
        :loadingImage="loadingImage"
        pageTitle="Dodajesz piosenkę"
        @change="handleBandLyricChange"
        @save="handleSave"
        @loadImage="handleLoadImage"
    />
    <Footer v-if="!isAndroidContext"/>
  </div>
</template>

<script>
import MainPageHeader from '../components/MainPageHeader.vue'
import { getBandLyricsService } from '../services/bandLyricsService'
import { getAuthService } from '../services/authService'
import BandLyricForm from '@/components/lyrics/BandLyricForm.vue'
import Footer from '@/components/Footer'
import LoaderLyrics from '@/components/lyrics/LoaderLyrics.vue'
import { getAndroidContext } from '@/services/sessionProps'

export default {
  name: 'CreateBandLyricPage',
  components: {
    Footer,
    MainPageHeader,
    BandLyricForm,
    LoaderLyrics,
  },

  data () {
    return {
      bandLyric: {
        key: null,
        title: this.$route.params.title || '',
        content: this.$route.params.content || '',
        duration: this.$route.params.duration,
        images: [],
      },
      saving: false,
      isEditingMode: false,
      isAndroidContext: false,
      loadingImage: false,
      lyricId: ''
    }
  },
  mounted () {
    window.scrollTo(0,0);
    (async () => {
      this.isAndroidContext = getAndroidContext().isAndroidContext()
      const [
        loggedInEmail,
      ] = await Promise.all([
        getAuthService().getLoggedInEmail(),
      ])

      this.loggedInEmail = loggedInEmail
      if (this.loggedInEmail == null) {
        this.$router.replace({
          name: 'logInPage',
          params: {fromPage: 'band-lyric/create'}
        })
      }
    })()
  },
  methods: {
    handleLoadImage(event){
      this.loadingImage = event
    },
    handleBandLyricChange (updatedFields) {
      this.bandLyric = {
        ...this.bandLyric,
        ...updatedFields,
      }
    },

    async handleSave (bandLyric, dir, tags) {
      this.saving = true
      let order = 0

      try {
        const bandLyricResource = await getBandLyricsService().createBandLyric(bandLyric)
        Object.assign(bandLyricResource.data, this.bandLyric);

        const payload = []

        tags.forEach(item => {
          let arrayTag = {
            name: item.value,
            bandLyric: [bandLyricResource.data['@id']]
          }
          payload.push(arrayTag)
        })

        for (const item of payload) {
          await getBandLyricsService().createBandLyricTags(item)
        }

        for (const image of this.bandLyric.images) {
          const imageResource = await getBandLyricsService()
              .createBandLyricPicture(bandLyricResource.data.id, image, order)
          if(imageResource === null)
            this.$root.showSnackbar("Błąd podczas przesyłania obrazka", "error")
          order++
        }
        this.$router.push('/lyrics')
      } catch (err) {
        console.error('[SHOW NOTIFY] DATA NOT SAVED')
        this.$root.showSnackbar("Błąd podczas przesyłania piosenki", "error")
      }

      this.saving = false
    },
  },
}
</script>

<style lang="scss" scoped>

.CreateBandLyrics {
  position: relative;
  padding-bottom: 20px;
}

</style>
